import React from "react";
import styled from "styled-components";

export default function Preloader() {
  return (
    <Container>
      <img src="/preloader.webp" alt="logo" />
    </Container>
  );
}

const Container = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  background-color: var(--cream);
  img {
    width: min(80%, 400px);
    height: auto;
    margin: auto;
  }
`;
